const env =
  (typeof import.meta !== "undefined" &&
    (import.meta as unknown as { env?: Record<string, string | undefined> })
      .env) ||
  (typeof process !== "undefined" ? process.env : {}) ||
  {};

export const SANITY_PROJECT_ID = env.SANITY_PROJECT_ID ?? "g38rxyoc";
export const SANITY_DATASET = env.SANITY_DATASET ?? "production";
export const SANITY_API_VERSION = "2023-05-03";
export const SANITY_REQUEST_TIMEOUT_MS = 10_000;

// Set SANITY_USE_CDN=false to disable the API-CDN (e.g. for the develop
// client, whose `drafts` perspective doesn't support the CDN). Defaults to
// true to preserve cached, published reads.
export const SANITY_USE_CDN = env.SANITY_USE_CDN !== "false";

export const IMAGE_PROXY_BASE_URL = env.IMAGE_PROXY_BASE_URL ?? "";
export const SANITY_CDN_BASE = `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${SANITY_DATASET}/`;
